import { render, staticRenderFns } from "./deleteSureDialog.vue?vue&type=template&id=fb2c9824"
import script from "./deleteSureDialog.vue?vue&type=script&lang=js"
export * from "./deleteSureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports